export default "__VITE_ASSET__3c7431ac__"